module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Update Quarter")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedCOGS.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total COGS Capped:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues.cogsCapped)))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total COGS Used:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues.cogsUsed)))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total COGS Excess:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues.cogsExcess)))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("COGS %:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.totalValues.cogsPercent) + "%")])])])], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isTopUsers) ? _c('v-form', {
    ref: "quarterForm",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.quarters,
      "item-value": "name",
      "item-text": "title",
      "label": "Quarter",
      "dense": "",
      "outlined": "",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.quarter),
      callback: function($$v) {
        _vm.$set(_vm.data, "quarter", $$v)
      },
      expression: "data.quarter"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isTopUsers) ? _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffb39552"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/COGSSummary/UpdateQuarterModal.vue
// module id = 2326
// module chunks = 0